<template>
    <main style="height:700px">
        <div>
            <div class="J-header-modal">
                <h2>Tus emprendimientos</h2>
            </div>
            <div class="J-body">
                <div class="J-list-company-item-container" v-if="1==0">
                    <div class="J-list-company-item">
                        <div class="J-list-img-container">
                            <div class="J-list-img">
                                <img :src="dataUser.photo== ''?'https://cdn.vuetifyjs.com/images/cards/foster.jpg' : dataUser.photo" alt="">
                            </div>
                        </div>
                        <div class="J-list-text">
                            <div class="J-list-title">
                                <h3>{{dataUser.fullname}}</h3>
                            </div>
                            <div class="J-list-description">
                               
                                <div >
                                    Al realizar click en <b>Unirse</b> sera parte de  <b>{{info.name.toUpperCase()}}</b> y podra recibir promociones, cupones de descuento.<br>
                                    Si realiza click en <b>Unirse como distribuidor</b>, usted solicitara a <b>{{info.name.toUpperCase()}}</b> para ser distribuidor de sus productos, una ves confirmado podra comprar al por mayor a un costo menor.
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="J-list-container-btn">
                        <button class="J-btn-primary color-primary default"><i class="fas fa-comment"></i><span class="J-m-l-10">Unirse</span></button>
                        <button class="J-btn-primary color-primary default"><i class="fas fa-comment"></i><span class="J-m-l-10">Unirse como distribuidor</span></button>
                    </div>
                </div>
                
                <div v-for="(company,i) in dataCompanies" :key="i+1">
                    <div class="J-list-company-item-container" v-if="info.category=='proveedor'&&company.category!='proveedor'&&info._id!=company._id">
                        <div class="J-list-company-item">
                            <div class="J-list-img-container">
                                <div class="J-list-img">
                                    <img :src="company.image_company.length <= 0?'https://cdn.vuetifyjs.com/images/cards/foster.jpg' : company.image_company[0].link" alt="">
                                </div>
                            </div>
                            <div class="J-list-text">
                                <div class="J-list-title">
                                    <h3>{{capitalizeFirstLetter(company.name)}}</h3>
                                </div>
                                <div class="J-list-description">
                                    {{company.description}}
                                    <div v-if="company.category=='proveedor'">
                                        Al realizar click en  <b>Unirse con este emprendimiento</b> usted solicitara a <b>{{info.name.toUpperCase()}}</b> para que sea distribuidor de su producto
                                    </div>
                                    <div v-else-if="company.category=='comerciante'&&company.company_created==info._id">
                                        Ya es un distribuidor de <b>{{info.name.toUpperCase()}}</b>
                                    </div>
                                    <div v-else>
                                        Al realizar click en <b>Unirse con este emprendimiento</b> usted solicitara a <b>{{info.name.toUpperCase()}}</b> para que su emprendimiento <b> {{company.name.toUpperCase()}} </b> se encargue de distribuir los productos de <b>{{info.name.toUpperCase()}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="J-list-container-btn">
                            <button v-if="company.category=='comerciante'&&company.company_created==info._id" class="J-btn-primary color-primary default"><i class="fas fa-comment"></i><span class="J-m-l-10">Ver productos con esta cuenta</span></button>
                            <button v-else class="J-btn-primary color-primary default" :disabled="company.success" @click="joinCompany(company,'distribuidor')"><i class="fas fa-comment"></i><span class="J-m-l-10">Unirse con este emprendimiento</span></button>
                        </div>
                        <div style="text-align: center;">
                            <span class="J-message-success-text" v-if="company.success">
                                Tu suscripción fue enviado correctamente
                            </span>
                            <span class="J-message-danger" v-else-if="company.success==false">
                                Error de suscripción
                            </span>
                        </div>
                    </div>


                    
                    <div class="J-list-company-item-container" v-else-if="info.category!='proveedor'&&info._id!=company._id">
                        <div class="J-list-company-item">
                            <div class="J-list-img-container">
                                <div class="J-list-img">
                                    <img :src="company.image_company.length <= 0?'https://cdn.vuetifyjs.com/images/cards/foster.jpg' : company.image_company[0].link" alt="">
                                </div>
                            </div>
                            <div class="J-list-text">
                                <div class="J-list-title">
                                    <h3>{{capitalizeFirstLetter(company.name)}}</h3>
                                </div>
                                <div class="J-list-description">
                                    {{company.description}}
                                    <div v-if="company.category=='proveedor'">
                                        Al realizar click en  <b>Unirse con este emprendimiento</b> usted solicitara a <b>{{info.name.toUpperCase()}}</b> para que sea distribuidor de su producto
                                    </div>
                                    <div v-else-if="company.category=='comerciante'&&company.company_created==info._id">
                                        Ya es un distribuidor de <b>{{info.name.toUpperCase()}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="J-list-container-btn">
                            <button v-if="company.category=='comerciante'" class="J-btn-primary color-primary default"><i class="fas fa-comment"></i><span class="J-m-l-10">Ver productos con esta cuenta</span></button>
                            <button v-else class="J-btn-primary color-primary default"><i class="fas fa-comment"></i><span class="J-m-l-10">Unirse con este emprendimiento</span></button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import {CompanyService} from '@/services/index.js'
    import {UsersStorage} from '@/helpers/storage.js'

export default {
    data:()=>({
        dataCompanies:[],
        usersStorage:new UsersStorage(),
        dataUser:{},
    }),
    components:{
    },
    props:{
        info:{type:String,required:true,default:false},
    },
    mounted(){
       this.getList()
       this.dataUser=this.usersStorage.get()
    },
    methods:{
        joinCompany(data,type){
            var data_send={
                "id":this.info._id,
                "id_company":data._id,
                "type": type,
            }
            CompanyService.addSubscriptions(data_send)
            .then(resp=>{
                this.$set(data,'success',true)
                console.log(resp)

            })
            .catch(err=>{
                this.$set(data,'success',false)
                console.log(err)
            })

        },
        getofficeadministration(){
            var query={
                
            }
            OfficeService.list(query).then(res=>{
                //console.log(res)
                if(res.data.results!=null){
                    this.dataoffice=res.data.results.office;
                    //console.log(this.dataoffice);
                    this.isTabActive(2);
                }
            })
        },
        getList(){
            CompanyService.list()
            .then(res=>{
                const {data}=res.data;
                if(data.companies!=null){
                    this.dataCompanies=data.companies;
                    
                    this.isTabActive(1);
                }

                })
            .catch(err=>{
                let msg = err
                
            })
        },
    },
    watch:{
      
    }

}
</script>